import { render } from "./SoftwareSolutions.vue?vue&type=template&id=41f2adba"
import script from "./SoftwareSolutions.vue?vue&type=script&lang=js"
export * from "./SoftwareSolutions.vue?vue&type=script&lang=js"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__